// extracted by mini-css-extract-plugin
export var chapterList = "OverviewTimeline-module--chapterList--f05ad";
export var chapterListItem = "OverviewTimeline-module--chapterListItem--f755c";
export var chapterTitle = "OverviewTimeline-module--chapterTitle--bbc5c";
export var expanded = "OverviewTimeline-module--expanded--44a0c";
export var hasSeen = "OverviewTimeline-module--hasSeen--afcbd";
export var last = "OverviewTimeline-module--last--60f86";
export var navButton = "OverviewTimeline-module--navButton--b93ca";
export var navigation = "OverviewTimeline-module--navigation--5ae4b";
export var overviewTimeline = "OverviewTimeline-module--overviewTimeline--dfa9f";
export var root = "OverviewTimeline-module--root--8bce7";
export var seen = "OverviewTimeline-module--seen--c9975";
export var videoItem = "OverviewTimeline-module--videoItem--72251";